angular.module('account.access-denied', [])
    .config(function ($stateProvider) {
        $stateProvider.state('access-denied', {
            parent: 'unauthenticated',
            views: {
                'content@': {
                    templateUrl: 'app/account/access-denied/access-denied.html'
                }
            }
        });
    })
